import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=00dd5bbf&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"
import style0 from "./Department.vue?vue&type=style&index=0&id=00dd5bbf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd5bbf",
  null
  
)

export default component.exports